import { Link } from "react-router-dom";
import cx from "classnames";
import LogoKIH from "../../assets/images/logo/KIH-logo.svg";
import LogoKIHWhite from "../../assets/images/logo/KIH-logo-white.svg";
import LogoUSPA from "../../assets/images/logo/USPA_Core Logo_Colour_RGB.svg";
import LogoUSPAWhite from "../../assets/images/logo/USPA-logo-white.svg";
import LogoKIHSmall from "../../assets/images/logo/KIH-logo-small.svg?react";
import LogoUSPASmall from "../../assets/images/logo/USPA_Logo_Small.svg?react";
import { isVersionUK } from "../../services/versionService";
import "./Logo.css";

const logo = isVersionUK ? LogoKIH : LogoUSPA;
const logoWhite = isVersionUK ? LogoKIHWhite : LogoUSPAWhite;
const LogoSmall = isVersionUK ? LogoKIHSmall : LogoUSPASmall;

const Logo = ({ isWhite, isSmall, className }) => (
    <Link
        to={isVersionUK ? "https://kingsinterhigh.co.uk/" : "/"}
        target={isVersionUK ? "_blank" : "_self"}
        className={cx("Logo", className)}
    >
        {isSmall ? <LogoSmall /> : <img alt="KIH" src={isWhite ? logoWhite : logo} />}
    </Link>
);

export default Logo;
